<template>
  <div>
    <v-row>
      <v-col cols="12">
        <SimplePageHeader class="px-0" title="Overtime Entries"></SimplePageHeader>
      </v-col>
    </v-row>
    <v-row justify="end">
      <v-col cols="12" sm="6" lg="4" xl="3">
        <v-btn block outlined color="primary" @click="$emit('addTempOvertimeEntry')">
          Add Entry
          <v-icon right >add</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-row v-for="(item, index) in overtimeEntriesTempArray" :key="index">
      <v-col cols="12">
        <OvertimeEntryInput
          :hourlyRate="hourlyRate"
          :id="index"
          :date="item.date"
          :otPayRate="item.otPayRate"
          :otBillRate="item.otBillRate"
          :hours="item.hours"
          :showDeleteButton="true"
          @dateChangeHandler="dateChangeHandler"
          @otPayRateChangeHandler="otPayRateChangeHandler"
          @otBillRateChangeHandler="otBillRateChangeHandler"
          @hoursChangeHandler="hoursChangeHandler"
          @removeTempOvertimeEntry="(id) => $emit('removeTempOvertimeEntry', id)"
        ></OvertimeEntryInput>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import OvertimeEntryInput from '@/components/overtime/OvertimeEntryInput'
import { ButtonCustomIcon } from '@/components/buttons'
import { SimplePageHeader } from '@/components/pageComponents'

export default {
  components: {
    OvertimeEntryInput,
    ButtonCustomIcon,
    SimplePageHeader
  },
  props: [
    'overtimeEntriesTempArray',
    'hourlyRate'
  ],
  methods: {
    dateChangeHandler ({ id, date }) {
      this.$emit('dateChangeHandler', id, date)
    },
    otPayRateChangeHandler ({ id, otPayRate }) {
      this.$emit('otPayRateChangeHandler', id, otPayRate)
    },
    otBillRateChangeHandler ({ id, otBillRate }) {
      this.$emit('otBillRateChangeHandler', id, otBillRate)
    },
    hoursChangeHandler ({ id, hours }) {
      this.$emit('hoursChangeHandler', id, hours)
    }
  }
}
</script>
